export enum SubscriptionApp {
    focuslee = 'focuslee',
    healthlee = 'healthlee',
}

export function resolveSubscriptionApp(app?: SubscriptionApp | null): SubscriptionApp {
    return app ?? SubscriptionApp.focuslee;
}

export function subscriptionInvoiceCopy(app: SubscriptionApp, isAdmin: boolean): { title: string; description: string } {
    const name = app === SubscriptionApp.healthlee ? 'HealthLee' : 'FocusLee';
    return {
        title: `${name} Premium${isAdmin ? ' (admin test)' : ''}`,
        description: 'Premium access in both FocusLee and HealthLee. Renews every 30 days.',
    };
}

export type ProductKind = 'subscription';

export interface PaymentProduct {
    kind: ProductKind;
    title: string;
    description: string;
    amount: number;
    subscriptionPeriod?: 2592000;
    tariff: string;
}

export const PAYMENT_PRODUCTS = {
    premium_monthly: {
        kind: 'subscription',
        title: 'FocusLee Premium',
        description: 'Monthly access to premium features.',
        amount: 250,
        subscriptionPeriod: 2592000,
        tariff: 'subscription_2026',
    },
    premium_monthly_admin: {
        kind: 'subscription',
        title: 'FocusLee Premium (admin test)',
        description: 'Monthly test subscription for FocusLee admins.',
        amount: 1,
        subscriptionPeriod: 2592000,
        tariff: 'subscription_admin_test_2026',
    },
} as const satisfies Record<string, PaymentProduct>;

export type ProductKey = keyof typeof PAYMENT_PRODUCTS;

export const PRODUCT_KEYS = {
    premiumMonthly: 'premium_monthly',
    premiumMonthlyAdmin: 'premium_monthly_admin',
} as const satisfies Record<string, ProductKey>;

export const TRIAL_TARIFF = 'trial_2026';
export const TRIAL_DURATION_SECONDS = 7 * 24 * 60 * 60;

const TRIAL_TARIFF_PREFIX = 'trial_';
const SUBSCRIPTION_TARIFF_PREFIX = 'subscription_';

export function isTrialTariff(tariff?: string | null): boolean {
    return Boolean(tariff?.startsWith(TRIAL_TARIFF_PREFIX));
}

export function isSubscriptionTariff(tariff?: string | null): boolean {
    return Boolean(tariff?.startsWith(SUBSCRIPTION_TARIFF_PREFIX));
}
